import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Dialog,
  Autocomplete,
  TextField,
  Typography,
  Avatar,
} from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CheckIcon from "@mui/icons-material/Check";
import CircleIcon from "@mui/icons-material/Circle";
import moment from "moment";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { ToastError } from "../../utils/Toaster/Toaster";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";
import AddRequest from "../../components/Request/AddRequest";
import { deleteRequest, getRequest } from "../../services/request";
import { REQUEST_STATUS } from "../../common/constant/constant";
import RequestHistory from "../../components/Request/RequestHistory";
import DislikeIcon from "../../assets/images/DislikeIcon.png";
import LikeIcon from "../../assets/images/LikeIcon.png";
import { getProject } from "../../services/project.service";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";
import { Stack } from "@mui/system";

const Request = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openHistoryDrawer, setOpenHistoryDrawer] = useState(false);
  const [data, setData] = useState([]);
  const [valueData, setValueData] = useState([]);
  const { accessToken } = useAuth();
  const { canAdd, canEdit, canDelete } = usePermissions();
  const [selectedData, setSelectedData] = useState({});
  const [tableTotalCount, setTableCount] = useState(0);
  const [who, setIsWho] = useState(false);
  const [user, setUser] = useState({});
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [queryParam, setQueryParam] = useState({
    status: null,
    projectId: null,
  });
  const getRequestData = async () => {
    try {
      const queryParams = { ...queryParam };

      // Fix role condition (check roles correctly)
      if (user.role === 3) {
        queryParams.client = user.id;
      } else if (user.role === 2) {
        queryParams.employee = user.id;
      }
      const res = await getRequest(queryParams);
      const truncateText = (text, maxLength = 30) => {
        if (!text) return "-";
        return text.length > maxLength
          ? text.substring(0, maxLength) + "..."
          : text;
      };
      const modifiedData = res.data.data.map((e) => {
        return {
          ...e,
          status:
            e?.status == REQUEST_STATUS.ACKNOWLEDAGED
              ? "Acknowledge"
              : e?.status == REQUEST_STATUS.COMPLETED
                ? "Completed"
                : REQUEST_STATUS.PENDING
                  ? "Not Set"
                  : "-",
          projectName: e?.project_info?.name || "-",
          clientName: e?.client_info?.name || "-",
          eventDate: moment(e?.date).format("DD/MM/YYYY"),
        };
      });
      setData(modifiedData);
      setValueData(res.data);
      setTableCount(res?.data?.totalCount || 0);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await getProject({ isEnabled: true });
      setProjects(response.data.data);
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, []);

  useEffect(() => {
    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        setUser(decodedToken);
        setIsWho(
          decodedToken.role === 1 ||
          decodedToken.role === 2 ||
          decodedToken.role === 4 ||
          decodedToken.role === 5 ||
          decodedToken.role === 6
        );
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  // console.log("Current Role (who):", who);

  useEffect(() => {
    if (user?.id) {
      getRequestData();
    }
  }, [user, queryParam]);

  const handleAdd = () => {
    setOpenDrawer(true);
    setSelectedData({});
  };

  const RequestOption = [
    { label: "All", name: "All", value: null },
    { label: "Pending", name: "Pending", value: REQUEST_STATUS.PENDING },
    { label: "Completed", name: "Completed", value: REQUEST_STATUS.COMPLETED },
    {
      label: "Acknowledge",
      name: "Acknowledge",
      value: REQUEST_STATUS.ACKNOWLEDAGED,
    },
  ];

  const handleView = (e) => {
    e.isView = true;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    e.isView = false;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleDelete = async (e) => {
    try {
      const res = await deleteRequest(e._id);
      getRequestData();
      ToastError(res.message);
    } catch (error) {
      console.log(error);
      ToastError(error?.data?.message || "something went wrong");
    }
  };

  const handleHistory = (e) => {
    setOpenHistoryDrawer(true);
    setSelectedData(e);
  };

  const columns = [
    { id: "projectName", label: "Project" },
    { id: "status", label: "status" },
    { id: "clientName", label: "Client" },
    { id: "title", label: "Title" },
    { id: "description", label: "Description" },
  ];

  const tableConfig = {
    isMore: true,
    isAction:
      user?.role == 1 || user?.role == 5 || user?.role == 6 || user?.role == 2 || user?.role == 3,
    isAdmin: true,
    isView: true,
    isEdit: canEdit("request"),
    isDelete: canDelete("request"),
    isHistory: true,
  };

  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content" }}>
        {/* MOBILE LAYOUT (Compact 2-col) */}
        <Box sx={{ display: { xs: "block", md: "none" }, overflowX: "hidden" }}>
          <Stack spacing={1} mb={2}>
            {/* Row 1: Completed and Acknowledged */}
            <Stack direction="row" spacing={1} alignItems="stretch">
              <Box flex={1} display="flex">
                <Box
                  display="flex"
                  fontFamily="inter"
                  alignItems="center"
                  bgcolor="#ffffff"
                  borderRadius="12px"
                  padding="8px"
                  gap={1}
                  width={"100%"}
                >
                  <Avatar sx={{ bgcolor: "#b3efb1", width: 22, height: 22 }}>
                    <img
                      src={DislikeIcon}
                      alt="Completed"
                      width="18px"
                      height="18px"
                    />
                  </Avatar>
                  <Typography
                    sx={{
                      fontSize: 13,
                      color: "#555",
                      fontWeight: "500",
                      flex: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    Completed
                    <Box component="span" fontWeight="bold" color="black">
                      {valueData?.completedCount || 0}
                    </Box>
                  </Typography>
                </Box>
              </Box>

              <Box flex={1} display="flex">
                <Box
                  display="flex"
                  alignItems="center"
                  bgcolor="#ffffff"
                  fontFamily="inter"
                  borderRadius="12px"
                  padding="8px"
                  gap={1}
                  width={"100%"}
                >
                  <Avatar sx={{ bgcolor: "#b3efb1", width: 22, height: 22 }}>
                    <img
                      src={LikeIcon}
                      alt="Added"
                      width="18px"
                      height="18px"
                    />
                  </Avatar>
                  <Typography
                    sx={{
                      fontSize: 13,
                      color: "#555",
                      fontWeight: "500",
                      flex: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    Acknowledge
                    <Box component="span" fontWeight="bold" color="black">
                      {valueData?.acknowledgedCount || 0}
                    </Box>
                  </Typography>
                </Box>
              </Box>
            </Stack>

            {/* Row 2: Unacknowledged and Add Button */}
            <Stack direction="row" spacing={1} alignItems="stretch">
              <Box flex={1} display="flex">
                <Box
                  display="flex"
                  alignItems="center"
                  fontFamily="inter"
                  bgcolor="#ffffff"
                  borderRadius="12px"
                  padding="8px"
                  gap={1}
                  width={"100%"}
                >
                  <Avatar sx={{ bgcolor: "#b3efb1", width: 22, height: 22 }}>
                    <CheckIcon sx={{ color: "#000000", fontSize: 14 }} />
                  </Avatar>
                  <Typography
                    sx={{
                      fontSize: 13,
                      color: "#555",
                      fontWeight: "500",
                      flex: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    UnAck
                    <Box component="span" fontWeight="bold" color="black">
                      {valueData?.unknowledgedCount || 0}
                    </Box>
                  </Typography>
                </Box>
              </Box>

              <Box flex={1} display="flex">
                <PermissionGate module="request" action="add">
                  <Button
                    startIcon={<AddOutlinedIcon />}
                    onClick={() => handleAdd()}
                    className="Add-Button w-100"
                    variant="contained"
                    size="small"
                    sx={{ width: "100%", height: "100%", minHeight: "36px", fontSize: "13px", borderRadius: "10px" }}
                  >
                    Add Request
                  </Button>
                </PermissionGate>
              </Box>
            </Stack>

            {/* Row 3: Filters */}
            <Stack direction="row" spacing={1} alignItems="stretch">
              {user?.role == 3 ? null : (
                <Box flex={1}>
                  <Autocomplete
                    options={projects}
                    getOptionLabel={(option) => option.name}
                    value={selectedProject}
                    onChange={(e, v) => {
                      setSelectedProject(v);
                      setQueryParam({
                        ...queryParam,
                        projectId: v ? v._id : null,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Project"
                        size="small"
                        sx={{
                          bgcolor: "white",
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "12px",
                            fontSize: "13px",
                            padding: "0px"
                          }
                        }}
                      />
                    )}
                  />
                </Box>
              )}

              <Box flex={user?.role == 3 ? 1 : 1}>
                <Autocomplete
                  options={RequestOption}
                  disableClearable={true}
                  value={
                    RequestOption.find(
                      (option) => option.value === queryParam.status
                    ) || null
                  }
                  onChange={(e, v) => {
                    setQueryParam({
                      ...queryParam,
                      status: v ? v.value : queryParam.status,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Status"
                      size="small"
                      sx={{
                        bgcolor: "white",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "12px",
                          fontSize: "13px",
                          padding: "0px"
                        }
                      }}
                    />
                  )}
                />
              </Box>
            </Stack>
          </Stack>
        </Box>

        {/* DESKTOP LAYOUT (User's Design) */}
        <Box sx={{ display: { xs: "none", md: "block" } }}>
          <Grid container spacing={2} alignItems="center" justifyContent="space-between">
            {/* Stats Cards Section */}
            <Grid item xs={12} md={7}>
              <Grid container spacing={2} alignItems="center">
                {/* Completed */}
                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    height="37px"
                    fontFamily="inter"
                    alignItems="center"
                    bgcolor="#ffffff"
                    borderRadius="12px"
                    padding="8px 16px"
                    gap={1}
                    width={"100%"}
                  >
                    <Avatar sx={{ bgcolor: "#b3efb1", width: 20, height: 20 }}>
                      <img
                        src={DislikeIcon}
                        alt="Completed"
                        width="20px"
                        height="20px"
                      />
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#555",
                        fontWeight: "500",
                        flex: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      Completed
                      <Box component="span" fontWeight="bold" color="black">
                        {valueData?.completedCount || 0}
                      </Box>
                    </Typography>
                  </Box>
                </Grid>

                {/* Acknowledged */}
                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    height="37px"
                    alignItems="center"
                    bgcolor="#ffffff"
                    fontFamily="inter"
                    borderRadius="12px"
                    padding="8px 16px"
                    gap={1}
                  >
                    <Avatar sx={{ bgcolor: "#b3efb1", width: 20, height: 20 }}>
                      <img
                        src={LikeIcon}
                        alt="Acknowledged"
                        width="20px"
                        height="20px"
                      />
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#555",
                        fontWeight: "500",
                        flex: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      Acknowledge
                      <Box component="span" fontWeight="bold" color="black">
                        {valueData?.acknowledgedCount || 0}
                      </Box>
                    </Typography>
                  </Box>
                </Grid>

                {/* Unacknowledged */}
                <Grid item xs={12} sm={4}>
                  <Box
                    display="flex"
                    height="37px"
                    alignItems="center"
                    fontFamily="inter"
                    bgcolor="#ffffff"
                    borderRadius="12px"
                    padding="8px 16px"
                    gap={1}
                  >
                    <Avatar sx={{ bgcolor: "#b3efb1", width: 20, height: 20 }}>
                      <CheckIcon sx={{ color: "#000000", fontSize: 12 }} />
                    </Avatar>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#555",
                        fontWeight: "500",
                        flex: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      UnAcknowledge
                      <Box component="span" fontWeight="bold" color="black">
                        {valueData?.unknowledgedCount || 0}
                      </Box>
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Grid>

            {/* Filters & Actions Section */}
            <Grid item xs={12} md={5}>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="flex-end"
              >
                {/* Project Filter */}
                {user?.role == 3 ? null : (
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      options={projects}
                      getOptionLabel={(option) => option.name}
                      value={selectedProject}
                      onChange={(e, v) => {
                        setSelectedProject(v);
                        setQueryParam({
                          ...queryParam,
                          projectId: v ? v._id : null,
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Project"
                          className="AutoComplete_InputBox"
                          size="small"
                        />
                      )}
                    />
                  </Grid>
                )}

                {/* Status Filter */}
                <Grid item xs={12} sm={4}>
                  <Autocomplete
                    options={RequestOption}
                    disableClearable={true}
                    value={
                      RequestOption.find(
                        (option) => option.value === queryParam.status
                      ) || null
                    }
                    className="w-100"
                    onChange={(e, v) => {
                      setQueryParam({
                        ...queryParam,
                        status: v ? v.value : queryParam.status,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Status"
                        className="AutoComplete_InputBox"
                        focused={false}
                        size="small"
                      />
                    )}
                  />
                </Grid>

                {/* Add Request Button */}
                <Grid item xs={12} sm={4}>
                  <PermissionGate module="request" action="add">
                    <Button
                      startIcon={<AddOutlinedIcon />}
                      onClick={() => handleAdd()}
                      className="Add-Button w-100"
                      variant="contained"
                      size="medium"
                      sx={{ height: "40px" }}
                    >
                      Add Request
                    </Button>
                  </PermissionGate>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <MasterCommonTable
        tableConfig={tableConfig}
        data={data}
        columns={columns}
        handleEdit={handleEdit}
        handleView={handleView}
        handleDelete={handleDelete}
        handleHistory={handleHistory}
        tableTotalCount={tableTotalCount}
      />
      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="sm"
      >
        {openDrawer ? (
          <AddRequest
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            GetData={getRequestData}
            userData={user}
          />
        ) : null}
      </Dialog>
      <Dialog
        open={openHistoryDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="sm"
      >
        {openHistoryDrawer ? (
          <RequestHistory
            selectedData={selectedData}
            setOpenHistoryDrawer={setOpenHistoryDrawer}
          />
        ) : null}
      </Dialog>
    </div>
  );
};

export default Request;
